import { render } from "./AccountsClosedList.vue?vue&type=template&id=1ded9244"
import script from "./AccountsClosedList.vue?vue&type=script&lang=js"
export * from "./AccountsClosedList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__